import React, { useState, useEffect } from 'react'
import close from '@assets/nuevos-iconos/x.png'
import { useUser } from '@context/user'
import * as Dialog from '@radix-ui/react-dialog'
import * as Form from '@radix-ui/react-form'
import * as Select from '@radix-ui/react-select'
// import flechaIco from '@assets/sidebar/Flecha.png'
import { AutenticateProxy } from '@proxies/auth'
import { useAppStore } from '@store'
import { getLanguageID } from '@utils/getLanguageID'
import { useNavigate } from 'react-router-dom'
import { ConfirmRegister } from '@components/ModalConfirm/ConfirmRegister'
import { getTiendas, TiendaApi } from '@proxies/getTiendas'

const SelectItem = React.forwardRef<HTMLDivElement, Select.SelectItemProps>(
  ({ children, ...props }, forwardedRef) => (
    <Select.Item
      {...props}
      ref={forwardedRef}
    >
      <Select.ItemText>{children}</Select.ItemText>
    </Select.Item>
  ),
)
SelectItem.displayName = 'SelectItem'

export type Props = {
  href: string
}

export function Register() {
  const textos = useAppStore.use.textos()
  const navigate = useNavigate()
  const userContext = useUser()
  const user = userContext?.user
  const userActions = userContext?.userActions
  const [errorMessage, setErrorMessage] = useState('')
  const [successMessage, setSuccessMessage] = useState('')
  const [showSaveConfirm, setShowSaveConfirm] = useState(false)
  const registerhref = '/planner/register'
  const [state, setState] = useState({
    nombre: '',
    apellidos: '',
    direccion: '',
    pais: '',
    ciudad: '',
    codigoPostal: '',
    telefono: '',
    correo: '',
    empresa: '',
    cif: '',
    password: '',
    passwordConfirmar: '',
    confirmarTerminos: false,
    aceptarOfertas: true,
  })
  // const idiomas = useAppStore.use.languageOptions()
  const openModal = useAppStore.use.openModal()
  const closeModal = useAppStore.use.closeModal()
  const [selectedTienda, setSelectedTienda] = useState<number | null>(null)
  const [isTiendaOpen, setIsTiendaOpen] = useState(false)
  const [tiendas, setTiendas] = useState<TiendaApi[]>([])

  useEffect(() => {
    openModal()
  }, [openModal])

  useEffect(() => {
    getTiendas().then(setTiendas)
  }, [])

  function t(str: string) {
    if (!textos.textos) return str
    if (!(str in textos.textos)) return str
    // @ts-expect-error: index type is string and textos.textos is a dictionary
    return textos.textos[str]
  }

  async function sendRegister() {
    if (!state.nombre) {
      setErrorMessage('El nombre es obligatorio')
      return
    }
    if (!state.correo) {
      setErrorMessage('El correo es obligatorio')
      return
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailRegex.test(state.correo)) {
      setErrorMessage('El correo no es válido')
      return
    }
    // Validación de tienda removida - campo oculto
    const proxy = new AutenticateProxy()

    await proxy
      .register({
        nombre: state.nombre,
        apellidos: state.apellidos,
        direccion: state.direccion,
        codigoPostal: state.codigoPostal,
        telefono: state.telefono,
        correo: state.correo,
        idIdioma: getLanguageID(
          'code',
          (user && 'nombreCultura' in user ? user.nombreCultura : '') || '',
        ),
        empresa: state.empresa,
        cif: state.cif,
        ciudad: state.ciudad,
        pais: state.pais,
        password: state.password,
        correoConfirmar: state.correo,
        passwordConfirmar: state.passwordConfirmar,
        confirmarTerminos: state.confirmarTerminos,
        idTiendas: selectedTienda || 1, // Valor por defecto si no hay tienda seleccionada
      })
      .then((data: any) => {
        if (user && 'nombreCultura' in user) userActions?.updateUser(user)
        openModal()
        if (data && !state.confirmarTerminos) {
          setErrorMessage(data?.detail)
        }

        if (data && data?.message) {
          // Mostrar el mensaje de éxito del backend
          setSuccessMessage(data.message)
          setErrorMessage('')
          closeModal()
          setShowSaveConfirm(true)

          // Navegar al login después de 7 segundos para dar tiempo de leer
          setTimeout(() => {
            navigate('/planner/login')
            closeModal()
          }, 7000)
        }
        if (data && data?.status === 500 && data?.detail === 'Ya existe el usuario') {
          setErrorMessage(data?.detail)
          setTimeout(() => {
            navigate('/planner/login')
          }, 1000)
          return
        }

        if (data && data?.status === 500) {
          setErrorMessage(data?.detail)
        }
      })
      .catch((error: any) => {
        openModal()
        navigate(
          window.location.pathname +
            `/error/${error?.detail || error?.statusText || error?.status || error}`,
        )
      })
  }

  return (
    <Dialog.Root open={true}>
      <div className='fixed inset-0 bg-white opacity-75' />
      <Dialog.Content
        id='register'
        onInteractOutside={(e) => {
          e.preventDefault()
          e.stopPropagation()
        }}
        className='absolute left-0 top-0 z-40 grid h-screen w-screen grid-cols-[2fr,1fr] items-center justify-center bg-C/ColorC01 text-left'
      >
        <Dialog.Title className='sr-only'>{t('Register')}</Dialog.Title>
        <Dialog.Description className='sr-only'>
          {'Guardado con exito'} - {'Activación cuenta'}
        </Dialog.Description>
        <div className='flex items-center justify-center'>
          <div
            id='register-inner'
            className='relative z-30 flex h-auto min-h-[480px] w-[745px] flex-col border-[1px] border-colorAtemporal bg-C/Color1 pb-4'
          >
            <Dialog.Close
              asChild
              onClick={() => {
                closeModal()
                navigate(-1)
              }}
            >
              <div className='absolute right-2.5 top-2.5 cursor-pointer'>
                <img
                  className='cursor-pointer'
                  role='button'
                  src={close}
                />
              </div>
            </Dialog.Close>

            <Form.Root autoComplete='off'>
              {/* Inputs ocultos como trampa para prevenir autocompletado */}
              <input
                type='text'
                autoComplete='off'
                style={{ position: 'absolute', left: '-9999px', opacity: 0, pointerEvents: 'none' }}
                tabIndex={-1}
                readOnly
              />
              <input
                type='password'
                autoComplete='off'
                style={{ position: 'absolute', left: '-9999px', opacity: 0, pointerEvents: 'none' }}
                tabIndex={-1}
                readOnly
              />
              <input
                type='email'
                autoComplete='off'
                style={{ position: 'absolute', left: '-9999px', opacity: 0, pointerEvents: 'none' }}
                tabIndex={-1}
                readOnly
              />
              {/* Título */}
              <div className='mb-4 ml-6 mt-6'>
                <h5 className='relative text-xl text-C/Color5'>
                  <span className='inline-block pb-1'>{'Registro'}</span>
                  <span
                    className='absolute bottom-0 left-0 right-0 border-b-2 border-colorAtemporal'
                    style={{ width: '200px' }}
                  ></span>
                </h5>
              </div>
              {/* Campos principales en dos columnas */}
              <div className='ml-6 flex w-[700px] gap-8'>
                <div className='flex-1 space-y-3'>
                  <Form.Field
                    name='nombre'
                    className='ModifyFormField mt-1 flex justify-between'
                  >
                    <Form.Label className='text-lg text-C/Color5'>{'Nombre'}</Form.Label>
                    <Form.Control asChild>
                      <input
                        className='Modifyinput h-7 w-[190px] border border-C/Color4 pl-1 text-base text-C/Color4'
                        maxLength={50}
                        value={state.nombre}
                        id='nombre'
                        autoComplete='off'
                        autoCorrect='off'
                        autoCapitalize='off'
                        spellCheck='false'
                        data-lpignore='true'
                        readOnly
                        onInput={(e) => {
                          e.currentTarget.removeAttribute('readonly')
                        }}
                        onKeyDown={(e) => {
                          if (e.currentTarget.hasAttribute('readonly')) {
                            e.currentTarget.removeAttribute('readonly')
                          }
                        }}
                        onPaste={(e) => {
                          e.currentTarget.removeAttribute('readonly')
                        }}
                        onChange={(e) =>
                          setState((prevState) => ({
                            ...prevState,
                            nombre: e.target.value,
                          }))
                        }
                      />
                    </Form.Control>
                  </Form.Field>
                  <Form.Field
                    name='empresa'
                    className='ModifyFormField mt-1 flex justify-between'
                  >
                    <Form.Label className='text-lg text-C/Color5'>{'Empresa'}</Form.Label>
                    <input
                      type='text'
                      name='company'
                      autoComplete='off'
                      style={{
                        position: 'absolute',
                        left: '-9999px',
                        opacity: 0,
                        pointerEvents: 'none',
                      }}
                      tabIndex={-1}
                      readOnly
                    />
                    <Form.Control asChild>
                      <input
                        className='Modifyinput h-7 w-[190px] border border-C/Color4 pl-1 text-base text-C/Color4'
                        maxLength={50}
                        value={state.empresa}
                        id='empresa'
                        autoComplete='off'
                        autoCorrect='off'
                        autoCapitalize='off'
                        spellCheck='false'
                        data-lpignore='true'
                        readOnly
                        onInput={(e) => {
                          e.currentTarget.removeAttribute('readonly')
                        }}
                        onKeyDown={(e) => {
                          if (e.currentTarget.hasAttribute('readonly')) {
                            e.currentTarget.removeAttribute('readonly')
                          }
                        }}
                        onPaste={(e) => {
                          e.currentTarget.removeAttribute('readonly')
                        }}
                        onChange={(e) =>
                          setState((prevState) => ({
                            ...prevState,
                            empresa: e.target.value,
                          }))
                        }
                      />
                    </Form.Control>
                  </Form.Field>
                  <Form.Field
                    name='direccion'
                    className='ModifyFormField mt-1 flex justify-between'
                  >
                    <Form.Label className='text-lg text-C/Color5'>{'Dirección'}</Form.Label>
                    <Form.Control asChild>
                      <input
                        className='Modifyinput h-7 w-[190px] border border-C/Color4 pl-1 text-base text-C/Color4'
                        maxLength={50}
                        value={state.direccion}
                        id='direccion'
                        autoComplete='off'
                        autoCorrect='off'
                        autoCapitalize='off'
                        spellCheck='false'
                        data-lpignore='true'
                        readOnly
                        onInput={(e) => {
                          e.currentTarget.removeAttribute('readonly')
                        }}
                        onKeyDown={(e) => {
                          if (e.currentTarget.hasAttribute('readonly')) {
                            e.currentTarget.removeAttribute('readonly')
                          }
                        }}
                        onPaste={(e) => {
                          e.currentTarget.removeAttribute('readonly')
                        }}
                        onChange={(e) =>
                          setState((prevState) => ({
                            ...prevState,
                            direccion: e.target.value,
                          }))
                        }
                      />
                    </Form.Control>
                  </Form.Field>
                  <Form.Field
                    name='codigoPostal'
                    className='ModifyFormField mt-1 flex justify-between'
                  >
                    <Form.Label className='text-lg text-C/Color5'>{'Código postal'}</Form.Label>
                    <Form.Control asChild>
                      <input
                        className='Modifyinput h-7 w-[120px] border border-C/Color4 pl-1 text-sm text-C/Color4'
                        type={'text'}
                        value={state.codigoPostal}
                        id='codigoPostal'
                        maxLength={50}
                        autoComplete='off'
                        autoCorrect='off'
                        autoCapitalize='off'
                        spellCheck='false'
                        data-lpignore='true'
                        readOnly
                        onInput={(e) => {
                          e.currentTarget.removeAttribute('readonly')
                        }}
                        onKeyDown={(e) => {
                          if (e.currentTarget.hasAttribute('readonly')) {
                            e.currentTarget.removeAttribute('readonly')
                          }
                        }}
                        onPaste={(e) => {
                          e.currentTarget.removeAttribute('readonly')
                        }}
                        onChange={(e) =>
                          setState((prevState) => ({
                            ...prevState,
                            codigoPostal: e.target.value,
                          }))
                        }
                      />
                    </Form.Control>
                  </Form.Field>
                  <Form.Field
                    name='correo'
                    className='ModifyFormField mt-1 flex justify-between'
                  >
                    <Form.Label className='text-lg text-C/Color5'>{'Correo'}</Form.Label>
                    {/* Input oculto como trampa para prevenir autocompletado */}
                    <input
                      type='email'
                      name='email'
                      autoComplete='off'
                      style={{
                        position: 'absolute',
                        left: '-9999px',
                        opacity: 0,
                        pointerEvents: 'none',
                      }}
                      tabIndex={-1}
                      readOnly
                    />
                    <Form.Control asChild>
                      <input
                        className='Modifyinput h-7 w-[190px] border border-C/Color4 pl-1 text-base text-C/Color4'
                        maxLength={50}
                        value={state.correo}
                        id='correo'
                        autoComplete='off'
                        autoCorrect='off'
                        autoCapitalize='off'
                        spellCheck='false'
                        data-lpignore='true'
                        readOnly
                        onInput={(e) => {
                          e.currentTarget.removeAttribute('readonly')
                        }}
                        onKeyDown={(e) => {
                          if (e.currentTarget.hasAttribute('readonly')) {
                            e.currentTarget.removeAttribute('readonly')
                          }
                        }}
                        onPaste={(e) => {
                          e.currentTarget.removeAttribute('readonly')
                        }}
                        onChange={(e) =>
                          setState((prevState) => ({
                            ...prevState,
                            correo: e.target.value,
                          }))
                        }
                      />
                    </Form.Control>
                  </Form.Field>
                  {/* Campo de tienda oculto - se asigna valor por defecto */}
                  <input
                    type='hidden'
                    value={selectedTienda || 1}
                  />
                </div>
                <div className='flex-1 space-y-3'>
                  <Form.Field
                    name='apellidos'
                    className='ModifyFormField mt-1 flex justify-between'
                  >
                    <Form.Label className='text-lg text-C/Color5'>{'Apellidos'}</Form.Label>
                    <Form.Control asChild>
                      <input
                        className='Modifyinput h-7 w-[190px] border border-C/Color4 pl-1 text-base text-C/Color4'
                        maxLength={50}
                        value={state.apellidos}
                        autoComplete='off'
                        autoCorrect='off'
                        autoCapitalize='off'
                        spellCheck='false'
                        data-lpignore='true'
                        readOnly
                        onInput={(e) => {
                          e.currentTarget.removeAttribute('readonly')
                        }}
                        onKeyDown={(e) => {
                          if (e.currentTarget.hasAttribute('readonly')) {
                            e.currentTarget.removeAttribute('readonly')
                          }
                        }}
                        onPaste={(e) => {
                          e.currentTarget.removeAttribute('readonly')
                        }}
                        onChange={(e) =>
                          setState((prevState) => ({
                            ...prevState,
                            apellidos: e.target.value,
                          }))
                        }
                      />
                    </Form.Control>
                  </Form.Field>

                  <Form.Field
                    name='cif'
                    className='ModifyFormField mt-1 flex justify-between'
                  >
                    <Form.Label className='text-lg text-C/Color5'>{'CIF'}</Form.Label>
                    <Form.Control asChild>
                      <input
                        className='Modifyinput h-7 w-[190px] border border-C/Color4 pl-1 text-base text-C/Color4'
                        type='string'
                        maxLength={50}
                        value={state.cif}
                        autoComplete='off'
                        autoCorrect='off'
                        autoCapitalize='off'
                        spellCheck='false'
                        data-lpignore='true'
                        readOnly
                        onInput={(e) => {
                          e.currentTarget.removeAttribute('readonly')
                        }}
                        onKeyDown={(e) => {
                          if (e.currentTarget.hasAttribute('readonly')) {
                            e.currentTarget.removeAttribute('readonly')
                          }
                        }}
                        onPaste={(e) => {
                          e.currentTarget.removeAttribute('readonly')
                        }}
                        onChange={(e) =>
                          setState((prevState) => ({
                            ...prevState,
                            cif: e.target.value,
                          }))
                        }
                      />
                    </Form.Control>
                  </Form.Field>
                  <Form.Field
                    name='ciudad'
                    className='ModifyFormField mt-1 flex justify-between'
                  >
                    <Form.Label className='text-lg text-C/Color5'>{'Ciudad'}</Form.Label>
                    <input
                      type='text'
                      name='city'
                      autoComplete='off'
                      style={{
                        position: 'absolute',
                        left: '-9999px',
                        opacity: 0,
                        pointerEvents: 'none',
                      }}
                      tabIndex={-1}
                      readOnly
                    />
                    <Form.Control asChild>
                      <input
                        className='Modifyinput h-7 w-[190px] border border-C/Color4 pl-1 text-base text-C/Color4'
                        maxLength={50}
                        value={state.ciudad}
                        autoComplete='off'
                        autoCorrect='off'
                        autoCapitalize='off'
                        spellCheck='false'
                        data-lpignore='true'
                        readOnly
                        onInput={(e) => {
                          e.currentTarget.removeAttribute('readonly')
                        }}
                        onKeyDown={(e) => {
                          if (e.currentTarget.hasAttribute('readonly')) {
                            e.currentTarget.removeAttribute('readonly')
                          }
                        }}
                        onPaste={(e) => {
                          e.currentTarget.removeAttribute('readonly')
                        }}
                        onChange={(e) =>
                          setState((prevState) => ({
                            ...prevState,
                            ciudad: e.target.value,
                          }))
                        }
                      />
                    </Form.Control>
                  </Form.Field>
                  <Form.Field
                    name='pais'
                    className='ModifyFormField mt-1 flex justify-between'
                  >
                    <Form.Label className='text-lg text-C/Color5'>{'Pais'}</Form.Label>
                    <input
                      type='text'
                      name='country'
                      autoComplete='off'
                      style={{
                        position: 'absolute',
                        left: '-9999px',
                        opacity: 0,
                        pointerEvents: 'none',
                      }}
                      tabIndex={-1}
                      readOnly
                    />
                    <Form.Control asChild>
                      <input
                        className='Modifyinput h-7 w-[190px] border border-C/Color4 pl-1 text-base text-C/Color4'
                        maxLength={50}
                        value={state.pais}
                        autoComplete='off'
                        autoCorrect='off'
                        autoCapitalize='off'
                        spellCheck='false'
                        data-lpignore='true'
                        readOnly
                        onInput={(e) => {
                          e.currentTarget.removeAttribute('readonly')
                        }}
                        onKeyDown={(e) => {
                          if (e.currentTarget.hasAttribute('readonly')) {
                            e.currentTarget.removeAttribute('readonly')
                          }
                        }}
                        onPaste={(e) => {
                          e.currentTarget.removeAttribute('readonly')
                        }}
                        onChange={(e) =>
                          setState((prevState) => ({
                            ...prevState,
                            pais: e.target.value,
                          }))
                        }
                      />
                    </Form.Control>
                  </Form.Field>
                  <Form.Field
                    name='telefono'
                    className='ModifyFormField mt-1 flex justify-between'
                  >
                    <Form.Label className='text-lg text-C/Color5'>{'Teléfono'}</Form.Label>
                    {/* Input oculto como trampa para prevenir autocompletado */}
                    <input
                      type='tel'
                      name='phone'
                      autoComplete='off'
                      style={{
                        position: 'absolute',
                        left: '-9999px',
                        opacity: 0,
                        pointerEvents: 'none',
                      }}
                      tabIndex={-1}
                      readOnly
                    />
                    <Form.Control asChild>
                      <input
                        className='Modifyinput h-7 w-[190px] border border-C/Color4 pl-1 text-base text-C/Color4'
                        type='tel'
                        maxLength={50}
                        value={state.telefono}
                        autoComplete='off'
                        autoCorrect='off'
                        autoCapitalize='off'
                        spellCheck='false'
                        data-lpignore='true'
                        readOnly
                        onInput={(e) => {
                          e.currentTarget.removeAttribute('readonly')
                        }}
                        onKeyDown={(e) => {
                          if (e.currentTarget.hasAttribute('readonly')) {
                            e.currentTarget.removeAttribute('readonly')
                          }
                        }}
                        onPaste={(e) => {
                          e.currentTarget.removeAttribute('readonly')
                        }}
                        onChange={(e) => {
                          const value = e.target.value
                          if (/^\+?\d*$/.test(value)) {
                            setState((prevState) => ({
                              ...prevState,
                              telefono: value,
                            }))
                            setErrorMessage('')
                          }
                        }}
                      />
                    </Form.Control>
                  </Form.Field>
                </div>
              </div>
              {/* Sección de contraseñas */}
              <div className='ml-6 mt-6 flex w-[700px] gap-8'>
                <div className='flex-1 space-y-3'>
                  <Form.Field
                    name='password'
                    className='ModifyFormField mt-1 flex justify-between'
                  >
                    <Form.Label className='text-lg text-C/Color5'>{'Contraseña'}</Form.Label>
                    <Form.Control asChild>
                      <input
                        className='Modifyinput h-7 w-[190px] flex-shrink-0 border border-C/Color4 pl-1 text-base text-C/Color4 placeholder-C/Color4'
                        type='password'
                        maxLength={50}
                        value={state.password}
                        autoComplete='off'
                        autoCorrect='off'
                        autoCapitalize='off'
                        spellCheck='false'
                        data-lpignore='true'
                        readOnly
                        onInput={(e) => {
                          e.currentTarget.removeAttribute('readonly')
                        }}
                        onKeyDown={(e) => {
                          if (e.currentTarget.hasAttribute('readonly')) {
                            e.currentTarget.removeAttribute('readonly')
                          }
                        }}
                        onPaste={(e) => {
                          e.currentTarget.removeAttribute('readonly')
                        }}
                        onChange={(e) =>
                          setState((prevState) => ({
                            ...prevState,
                            password: e.target.value,
                          }))
                        }
                      />
                    </Form.Control>
                  </Form.Field>
                  <Form.Field
                    name='confPassword'
                    className='ModifyFormField mt-1 flex justify-between'
                  >
                    <Form.Label className='text-lg text-C/Color5'>
                      {'Confirmar contraseña'}
                    </Form.Label>
                    <Form.Control asChild>
                      <input
                        className='Modifyinput h-7 w-[190px] flex-shrink-0 border border-C/Color4 pl-1 text-C/Color4 placeholder-C/Color4'
                        type='password'
                        maxLength={50}
                        value={state.passwordConfirmar}
                        autoComplete='off'
                        autoCorrect='off'
                        autoCapitalize='off'
                        spellCheck='false'
                        data-lpignore='true'
                        readOnly
                        onInput={(e) => {
                          e.currentTarget.removeAttribute('readonly')
                        }}
                        onKeyDown={(e) => {
                          if (e.currentTarget.hasAttribute('readonly')) {
                            e.currentTarget.removeAttribute('readonly')
                          }
                        }}
                        onPaste={(e) => {
                          e.currentTarget.removeAttribute('readonly')
                        }}
                        onChange={(e) =>
                          setState((prevState) => ({
                            ...prevState,
                            passwordConfirmar: e.target.value,
                          }))
                        }
                      />
                    </Form.Control>
                  </Form.Field>
                </div>
                <div className='flex flex-1 flex-col justify-between'>
                  <Form.Field
                    name='confTerminos'
                    className='ModifyFormField mt-1 flex justify-between'
                  >
                    <div className='terminosUso'>
                      <Form.Control asChild>
                        <input
                          className='mr-2'
                          type='checkbox'
                          checked={state.confirmarTerminos}
                          onChange={(e) =>
                            setState((prevState) => ({
                              ...prevState,
                              confirmarTerminos: e.target.checked,
                            }))
                          }
                        />
                      </Form.Control>
                      <a>
                        <span className='text-base text-C/Color4'>{'He leido y acepto la'} </span>
                      </a>
                      <a
                        className='hipervinculo'
                        href='https://atemporal.casa/politica-de-privacidad/'
                        target='_blank'
                        rel='noreferrer'
                      >
                        <span className='text-base text-C/Color5'>
                          {' ' + 'Política de Privacidad'}{' '}
                        </span>
                      </a>
                      <span className='text-base text-C/Color4'>
                        {' ' + 'y confirmo los términos' + ' '}
                      </span>
                    </div>
                  </Form.Field>
                  <Form.Submit asChild>
                    <div className='mt-1 flex flex-col items-end'>
                      {/* Espacio fijo reservado para mensajes - siempre mismo tamaño */}
                      <div
                        className={`mb-2 flex min-h-[40px] items-center justify-start text-start text-sm ${
                          successMessage
                            ? 'w-[300px] text-C/Color5'
                            : errorMessage
                              ? 'w-[200px] text-C/Color6'
                              : 'w-[200px] text-C/Color5'
                        }`}
                      >
                        {errorMessage || successMessage || '\u00A0'}
                      </div>
                      <div className='flex h-[40px] w-[200px] cursor-pointer items-center justify-center rounded-xl border-[1px] border-colorAtemporal bg-C/Color1 px-4 py-2 shadow-md transition-all hover:border-C/Color4 hover:bg-C/Color2 hover:shadow-lg active:scale-95'>
                        <span
                          onClick={() => {
                            sendRegister()
                          }}
                          className='inline-block text-lg font-medium text-C/Color3'
                        >
                          {'Crear cuenta'}
                        </span>
                      </div>
                      <span
                        className='mt-1 cursor-pointer text-xs text-C/Color4 transition-colors hover:text-C/Color3'
                        onClick={() => {
                          closeModal()
                          navigate('/planner/login')
                        }}
                      >
                        {'¿Ya tienes cuenta? Inicia sesion'}
                      </span>
                    </div>
                  </Form.Submit>
                </div>
              </div>
            </Form.Root>
          </div>
        </div>
        <div className='col-span-1 flex h-full min-w-full bg-bgLogin bg-contain bg-right bg-no-repeat'></div>
      </Dialog.Content>
      {showSaveConfirm && <ConfirmRegister message={successMessage} />}
    </Dialog.Root>
  )
}
